export default {
  superAdmin: 2,
  admin: 1,
  user: 0,
};
